<template>
  <div class="eds-form">
    <div class="content">
      <div class="text-content">
        <TextComponent
          class="form-element"
          :disabled="true"
          :fieldName="fieldName"
          v-model="fileName" />
      </div>
      <div class="position-content">
        <div class="form-element bottom">
          <label>
            <input type="file" @change="handleFileName" :accept="acceptType" :multiple="isMultiple" />
            <span class="btn">
              <i class="icon icon-upload"></i>
              Choose file
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextComponent from './TextComponent.vue';

export default {
  components: {
    TextComponent,
  },

  props: {
    fieldName: {
      type: String,
      required: true,
    },
    value: {
      type: [ String, Array ],
      default: '',
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    acceptType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      fileName: '',
    };
  },

  watch: {
    value: function() {
      this.fileName = this.value ?? '';
    }
  },

  mounted() {
    this.fileName = this.value ?? '';
  },

  methods: {
    handleFileName(event) {
      let file = null;
      if (event.target.files.length && event.target.files.length > 1) {
        let names = [];
        event.target.files.forEach(element => {
          names.push(element.name);
        });
        this.fileName = names.join();
      } else {
        file = event.target.files[0];
        this.fileName = event.target.files[0].name;
      }
      this.$emit('changeValue', this.fileName, file);
    },
  },
};
</script>

<style lang="less" scoped>

.content {
  display: flex;
  align-content: space-around;
  width: 100%;
}
.position-content {
  align-self: end;
}

.text-content {
  padding-right: 1rem;
  width: 75%;
}

.form-element {
  min-width: 9vw;
}

label {
  margin-bottom: 0px;
}
</style>